<template>
  <a-layout-content >
    <a-layout>
      <a-layout-content>
        <p>Account Administration</p>
        <a-card style="margin: 20px 0;">
          <p><b>These are your login credentials for you to access the Business Web Portal.
            These details are not displayed in the App or to your customers in any way.</b></p>
          <a-form
            forme="settings"
            submit="handleSubmit"
          >
            <div>
              <a-form-item
              label="Email"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-input
                type="Email"
                v-decorator="[
          'note',
          {rules: [{ required: true, message: 'Please input your note!' }]}
        ]"
                :value="this.newUser.email"
                @change="accountChanges('email', $event.target.value)"
              />
            </a-form-item>
            <a-form-item
              label="Password"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 12 }"
            >
              <a-input
                type="password"
                placeholder="Leave empty if you don't want to change"
                v-decorator="[
          'note',
          {rules: [{ required: true, message: 'Please input your note!' }]}
        ]"
                @change="accountChanges('password', $event.target.value)"
              />
            </a-form-item>
            </div>
            <a-button
            type="primary"
            @click="saveAccountChanges"
            style="width: max-content;margin: 24px"
          >
            Save
          </a-button>
          </a-form>
        <p v-if="errorName"> {{errorName}}</p>
        </a-card>
        <p>Business Profile Settings</p>
        <a-card style="margin: 20px 0;" v-if="this.business">
          <p><b>For each section populated below, we will display this information in the Customer Application for users to see.</b></p>
          <a-row style="justify-content: space-between;display: flex;align-items: center;">
            <a-col :span="16">
              <a-form>
              <a-form-item
                label="Business Name"
                :label-col="{ span: 24 }"
                :wrapper-col="{ span: 16 }"
                :validate-status="errors.has('business name') ? 'error' : null"
                :help="errors.first('business name')"
              >
                <a-input
                  v-validate="'required'"
                  name="business name"
                  @change="onAddressChange('name', $event.target.value)"
                  :value="this.business.name"
                />
              </a-form-item>
              </a-form>
            </a-col>
            <a-col style="flex: 0.4;">
              <a-upload
                      class="business-logo-upload"
                :fileList="fileList"
                :change="handleRemove"
                listType="picture"
                @remove="fileList = []"
                :beforeUpload="beforeUpload"
              >
                <a-button>
                  <a-icon type="upload" /> Select Logo
                </a-button>
              </a-upload>
            </a-col>
            <!--<a-col style="flex: 0.4;" v-else>-->
              <!--<a-upload-->
                <!--:change="handleRemove"-->
                <!--listType="picture"-->
              <!--&gt;-->
                <!--<a-button>-->
                  <!--<a-icon type="upload" /> Select File-->
                <!--</a-button>-->
              <!--</a-upload>-->
            <!--</a-col>-->
          </a-row>
          <h3>Business Hours</h3>
          <div v-if="this.business.working_hours">
            <div class="timeRow" >
              <span class="weekday">Monday</span>
              <a-input size="large"
                       :value="business.working_hours.monday.from"
                       pattern="[0-2][0-9]:[0-5][0-9]"
                       @change="onWorkingHoursChange('monday', 'from', $event.target.value)"/>
              <span>to</span>
              <a-input size="large"
                       :value="business.working_hours.monday.to"
                       pattern="[0-2][0-9]:[0-5][0-9]"
                       @change="onWorkingHoursChange('monday', 'to', $event.target.value)"/>
              <a-checkbox :value="!business.working_hours.monday.closed"
                          @change="onClosedChange('monday', $event.target.value)"
                          :checked="business.working_hours.monday.closed">
                CLOSED
              </a-checkbox>
            </div>
            <div class="timeRow">
              <span class="weekday">Tuesday:</span>
              <a-input size="large"
                       :value="business.working_hours.tuesday.from"
                       pattern="[0-2][0-9]:[0-5][0-9]"
                       @change="onWorkingHoursChange('tuesday', 'from', $event.target.value)"/>
              <span>to</span>
              <a-input size="large"
                       :value="business.working_hours.tuesday.to"
                       pattern="[0-2][0-9]:[0-5][0-9]"
                       @change="onWorkingHoursChange('tuesday', 'to', $event.target.value)"/>
              <a-checkbox :value="!business.working_hours.tuesday.closed"
                          @change="onClosedChange('tuesday', $event.target.value)"
                          :checked="business.working_hours.tuesday.closed">
                CLOSED
              </a-checkbox>
            </div>
            <div class="timeRow">
              <span class="weekday">Wednesday</span>
              <a-input size="large"
                       :value="business.working_hours.wednesday.from"
                       pattern="[0-2][0-9]:[0-5][0-9]"
                       @change="onWorkingHoursChange('wednesday', 'from', $event.target.value)"/>
              to
              <a-input size="large"
                       :value="business.working_hours.wednesday.to"
                       pattern="[0-2][0-9]:[0-5][0-9]"
                       @change="onWorkingHoursChange('wednesday', 'to', $event.target.value)"/>
              <a-checkbox :value="!business.working_hours.wednesday.closed"
                          @change="onClosedChange('wednesday', $event.target.value)"
                          :checked="business.working_hours.wednesday.closed">
                CLOSED
              </a-checkbox>
            </div>
            <div class="timeRow">
              <span class="weekday">Thursday</span>
              <a-input size="large"
                       :value="business.working_hours.thursday.from"
                       pattern="[0-2][0-9]:[0-5][0-9]"
                       @change="onWorkingHoursChange('thursday', 'from', $event.target.value)"/>
              <span>to</span>
              <a-input size="large"
                       :value="business.working_hours.thursday.to"
                       pattern="[0-2][0-9]:[0-5][0-9]"
                       @change="onWorkingHoursChange('thursday', 'to', $event.target.value)"/>
              <a-checkbox :value="!business.working_hours.thursday.closed"
                          @change="onClosedChange('thursday', $event.target.value)"
                          :checked="business.working_hours.thursday.closed">
                CLOSED
              </a-checkbox>
            </div>
            <div class="timeRow">
              <span class="weekday">Friday</span>
              <a-input size="large"
                       :value="business.working_hours.friday.from"
                       pattern="[0-2][0-9]:[0-5][0-9]"
                       @change="onWorkingHoursChange('friday', 'from', $event.target.value)"/>
              <span>to</span>
              <a-input size="large"
                       :value="business.working_hours.friday.to"
                       pattern="[0-2][0-9]:[0-5][0-9]"
                       @change="onWorkingHoursChange('friday', 'to', $event.target.value)"/>
              <a-checkbox :value="!business.working_hours.friday.closed"
                          @change="onClosedChange('friday', $event.target.value)"
                          :checked="business.working_hours.friday.closed">
                CLOSED
              </a-checkbox>
            </div>
            <div class="timeRow">
              <span class="weekday">Saturday</span>
              <a-input  size="large"
                        :value="business.working_hours.saturday.from"
                        pattern="[0-2][0-9]:[0-5][0-9]"
                        @change="onWorkingHoursChange('saturday', 'from', $event.target.value)"/>
              <span>to</span>
              <a-input  size="large"
                        :value="business.working_hours.saturday.to"
                        pattern="[0-2][0-9]:[0-5][0-9]"
                        @change="onWorkingHoursChange('saturday', 'to', $event.target.value)"/>
              <a-checkbox :value="!business.working_hours.saturday.closed"
                          @change="onClosedChange('saturday', $event.target.value)"
                          :checked="business.working_hours.saturday.closed">
                CLOSED
              </a-checkbox>
            </div>
            <div class="timeRow">
              <span class="weekday">Sunday</span>
              <a-input size="large"
                       :value="business.working_hours.sunday.from"
                       pattern="[0-2][0-9]:[0-5][0-9]"
                       @change="onWorkingHoursChange('sunday', 'from', $event.target.value)"/>
              <span>to</span>
              <a-input  size="large"
                        :value="business.working_hours.sunday.to"
                        pattern="[0-2][0-9]:[0-5][0-9]"
                        @change="onWorkingHoursChange('sunday', 'to', $event.target.value)"/>
              <a-checkbox :value="!business.working_hours.sunday.closed"
                          @change="onClosedChange('sunday', $event.target.value)"
                          :checked="business.working_hours.sunday.closed">
                CLOSED
              </a-checkbox>
            </div>
          </div>
          <p>Business Hours - Special Comments</p>
          <a-textarea placeholder="e.g. Temporarily closed daily between 1pm-2pm."
                      :rows="4"
                      @change="onAddressChange('working_hours_comment', $event.target.value)"
                      :value="business.working_hours_comment"/>
          <a-divider/>
          <h3>Business Address</h3>
          <div class="containMap">
          <div style="flex:0.5;">
              <p>Street Address</p>
              <a-input placeholder="Street Line 1"
                       size="large"
                       style="margin-bottom: 20px"
                       name="street1"
                       @change="onAddressChange('address', $event.target.value)"
                       :value="business.address"/>
            <a-input placeholder="Street Line 2"
                     size="large"
                     name="street2"
                     style="margin-bottom: 20px"
                     @change="onAddressChange('address_line2', $event.target.value)"
                     :value="business.address_line2"/>
              <p>City</p>
              <a-input placeholder="Sydney"
                       size="large"
                       name="city"
                       style="margin-bottom: 20px"
                       @change="onAddressChange('city', $event.target.value)"
                       :value="business.city"
              />
            <div style="flex:1;display: flex;justify-content: space-between;">
              <div style="padding-right: 10px">
                <p>Postcode</p>
                <a-input
                  placeholder="2200"
                  size="large"
                  name="postcode"
                  @change="onAddressChange('postcode', $event.target.value)"
                  :value="business.postcode"
                />
              </div>
              <div style="padding-right: 10px">
                <p>State/Territory</p>
                <a-input
                  placeholder="NSW"
                  size="large"
                  name="state"
                  @change="onAddressChange('state', $event.target.value)"
                  :value="business.state"
                />
              </div>
              <div>
                <p>Country</p>
                <a-input placeholder="Australia"
                         size="large"
                         name="country"
                         @change="onAddressChange('country', $event.target.value)"
                         :value="business.country"
                />
              </div>
            </div>
            <a-button @click="geocodeAddress"
                      type="primary"
                      style="margin: 40px 0 0 auto;display: flex;">
              Add Marker to Map
            </a-button>
          </div>
            <div class="myMap">
              <a-card style="flex: 1;">
                <google-map :position="mapPosition"
                            @drag="onMarkerDrag">
                </google-map>
              </a-card>
            </div>
          </div>
          <div style="width: 40%;">
          </div>
          <div>
            <a-divider/>
            <h3>Business Contact</h3>
            <p>Phone
              <a-input placeholder="+61 123 456 789"
                       :value="business.phone"
                       pattern="+[0-9]{2} [0-9]{3} [0-9]{3} [0-9]{3}"
                       name="phone"
                       @change="onAddressChange('phone', $event.target.value)"/>
            </p>
            <p>Email
              <a-input placeholder="business@domain.com"
                       name="email"
                       @change="onAddressChange('email', $event.target.value)"
                       :value="business.email"/>
            </p>
            <p>Website
              <a-input placeholder="domain.com"
                       @change="onAddressChange('website', $event.target.value)"
                       :value="business.website"/>
            </p>
          </div>
          <div>
            <a-divider/>
            <h3>Social Media URLs</h3>
            <p>Facebook
              <a-input placeholder="https://www.facebook.com/Yesloyal-430927457646625/"
                       @change="onAddressChange('facebook', $event.target.value)"
                       :value="business.facebook"/>
            </p>
            <p>Twitter
              <a-input placeholder="https://twitter.com/yesloyal1"
                       @change="onAddressChange('twitter', $event.target.value)"
                       :value="business.twitter"/>
            </p>
            <p>Instagram
              <a-input placeholder="https://www.instagram.com/loyaltyprograms/"
                       @change="onAddressChange('instagram', $event.target.value)"
                       :value="business.instagram"/>
            </p>
            <p>Pinterest
              <a-input placeholder="https://www.pinterest.co.uk/hogan1579/pins/"/>
            </p>
          </div>
          <a-button type="primary"
                    style="display: flex;: 1;margin: 0 auto;"
                    @click="saveBusiness"
                    >
            Save
          </a-button>
        </a-card>
        <a-modal
          v-model="saveModal"
          title="Save Changes?"
          onOk="handleOk"
        >
          <template slot="footer">
            <a-button type="primary" @click="handleOk">
              Save
            </a-button>
            <a-button @click="handleCancel">Cancel</a-button>
            <a-button @click="handleDiscard">Discard</a-button>
          </template>
          <p>There are unsaved changes on this page. Would you like to save these changes?</p>
        </a-modal>
      </a-layout-content>
    </a-layout>
  </a-layout-content>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import {API_URL} from '../../constants'
import googleMap from './googleMap.vue'

export default {
  name: 'Settings',
  data () {
    return {
      message: '',
      API_URL,
      accountEdit: false,
      fileList: [],
      edited: false,
      saveModal: false,
      myInputModel: '',
      mapPosition: {lat: 0, lng: 0},
      routeTo: '',
    }
  },
  mounted () {
    this.$store.dispatch('business/getSettingsData')
    this.newUser['email'] = this.user.email
    // this.$router.addEventListener("beforeunload", this.beforeRouteLeave())
    if (this.business) {
      this.fileList = [{
        uid: this.business.id,
        name: this.business.logo,
        status: 'done',
        url: `${API_URL}${this.business.logo}`,
      } ]
    }
  },
  watch: {
    'business.logo': function (newImage) {
      this.fileList = [{
        uid: newImage,
        name: newImage,
        status: 'don',
        url: `${API_URL}${newImage}`,
      } ]
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.edited) {
      return next()
    }
    this.routeTo = to
    if (this.edited) {
      return this.beforeLeaveModal()
    }
  },
  methods: {

    onAddressChange (field, value) {
      this.$store.commit('business/onAddressChange', {field, value})
      this.edited = true
    },
    onClosedChange (weekDay, value) {
      this.$store.commit('business/onClosedChange', {weekDay, value})
      this.edited = true
    },
    onWorkingHoursChange (weekDay, field, value) {
      const parts = value.split(':')

      if (parts.length === 1 && parts[0].length === 3) {
        parts[1] = parts[0].slice(2, 1)
        parts[0] = parts[0].slice(0, 2)
      }

      if (parts[0] >= 24 || parts[0] === '000') {
        parts[0] = '23'
      }
      if (parts[1] && (parts[1] > 59 || parts[1] === '000')) {
        parts[1] = '00'
      }
      const time = parts.join(':')
      this.$store.commit('business/onWorkingHoursChange', {weekDay, field, time})
      // this.edited = true
    },
    accountChanges (field, value) {
      this.$store.commit('business/accountChanges', {field, value})
    },
    saveAccountChanges () {
      this.$store.dispatch('business/saveAccountChanges')
      this.$message.success('New settings submited')
    },
    handleOk () {
      this.edited = false
      this.$store.dispatch('business/saveAccountChanges')
      this.$store.dispatch('business/saveBusiness', this.fileList.length && this.fileList[0])
      this.saveModal = false
      this.$router.push(this.routeTo.name)
    },
    handleDiscard () {
      this.edited = false
      this.saveModal = false
      this.$router.push(this.routeTo.name)
    },
    handleCancel () {
      this.edited = false
      this.saveModal = false
    },
    moment,
    logout () {
      this.$store.dispatch('auth/logout')
    },
    navigate (name) {
      this.$router.push({name})
    },
    handleRemove (file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.edited = true
    },
    beforeLeaveModal () {
      this.saveModal = true
    },
    beforeUpload (file) {
      this.fileList = [file]
      this.edited = true
      return false
    },
    onMarkerDrag (newCoordinates) {
      this.mapPosition = newCoordinates
      // var input = `${newCoordinates.lat}, ${newCoordinates.lng}`
      // const geocoder = new google.maps.Geocoder()
      // const settings = this.$store.state.business.business
      // var latlngStr = input.split(',', 2);
      // var latLng = {lat: parseFloat(latlngStr[0]), lng: parseFloat(latlngStr[1])};
      // geocoder.geocode({'latLng': latLng}, (results, status) => {
      //   if (status === 'OK') {
      //     let addressBus = results[0].formatted_address.split(',')
      //     settings.country = addressBus.slice(-1)
      //     settings.street = addressBus.slice(0,1)
      //     let cityState = addressBus.slice(1,2)
      //     cityState = cityState.join(' ').split(' ')
      //     settings.postcode = cityState.slice(-1)
      //     settings.statm = cityState.slice(-2,-1)
      //     settings.city = cityState.slice(1,-2).join(' ')
      //   }
      // })
    },
    geocodeAddress () {
      const geocoder = new google.maps.Geocoder()
      const settings = this.business
      const address = `${settings.address}, ${settings.address_line2}, ${settings.city}, ${settings.postcode}, ${settings.state}, ${settings.country}`
      geocoder.geocode({'address': address}, (results, status) => {
        if (status === 'OK') {
          this.business.location.coordinates[1] = results[0].geometry.location.lat()
          this.business.location.coordinates[0] = results[0].geometry.location.lng()
          this.mapPosition = results[0].geometry.location
          this.$message.success('Marker added to map')
        }
      })
    },
    async saveBusiness () {
      const result = await this.$validator.validateAll()
      if (!result) {
        this.$message.error('Please fill in all required fields.')
        return
      }
      this.$message.success('New settings saved.')
      await this.$store.dispatch('business/saveBusiness', this.fileList.length && this.fileList[0])
    },
  },
  components: {
    googleMap,
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      business: state => state.business.business,
      newUser: state => state.business.newUser,
      errorName: state => state.business.errorName,
    }),
  },
}
</script>

<style lang="scss">
  @import "./../../assets/styles";
  .avatar-uploader > .ant-upload {
    width: 250px;
    height: 150px;
  }
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }
  .vue-map {
    width:100%;
    height: 600px;
    display: block;
  }
  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
  .weekday {
    width: 100px;
    display: inline-block;
  }
  .ant-time-picker {
    margin: 0 20px;
  }
  .timeRow{
    margin: 10px 0;
  }
  .timeRow .ant-input {
    width: 100px;
    margin: 0 10px;
  }

  .business-logo-upload .ant-upload-list-item-name{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/Settings.vue